import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from '../../../../constants/style';

export const useStyles = makeStyles(() =>
  createStyles({
    paginationContainer: {
      display: 'flex',
      justifyContent: 'center',
    },
    pagination: {
      '& .MuiPaginationItem-root': {
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '0%',
        textAlign: 'center',
        verticalAlign: 'middle',
        color: STYLE.COLOR.TEXT2,
        margin: '0 7.5px',
      },
      '& .MuiPaginationItem-previousNext': {
        border: `1px solid ${STYLE.COLOR.STROKE_DEFAULT}`,
      },
    },
  }),
);
